import styled from 'styled-components';
export var ListItem = /*#__PURE__*/styled.li.withConfig({
  componentId: "sc-1ilsx2i-0"
})(["list-style-type:disc;"]);
export var List = /*#__PURE__*/styled.ul.withConfig({
  componentId: "sc-1ilsx2i-1"
})(["padding-left:", ";"], function (props) {
  return props.theme.space(13);
});